import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const technical = {
  fetchTechnicalArticles: lazyModuleMethod(
    () => import('./fetchTechnicalArticles'),
    'default'
  ),
  fetchTechnicalArticle: lazyModuleMethod(
    () => import('./fetchTechnicalArticle'),
    'default'
  ),
  createTechnicalArticle: lazyModuleMethod(
    () => import('./createTechnicalArticle'),
    'default'
  ),
  editTechnicalArticle: lazyModuleMethod(
    () => import('./editTechnicalArticle'),
    'default'
  ),
  deleteTechnicalArticle: lazyModuleMethod(
    () => import('./deleteTechnicalArticle'),
    'default'
  ),
}
